import { inject, Injectable } from '@angular/core';
import {
  ID,
  IPaginationOutput,
  IResearchCode,
  IUserChangePasswordInput,
  IUserInfo,
} from '@cardium/contracts';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private readonly http = inject(HttpClient);
  private readonly url = 'api/core/user/User';
  private readonly profileUrl = 'api/core/administration/Profile';

  public getMe() {
    return this.http.get<IUserInfo>(`${this.url}/me`);
  }

  public changeUserPassword(data: IUserChangePasswordInput) {
    return this.http.post(`${this.url}/changeProfilePassword`, data);
  }

  public block(userId: ID) {
    return this.http.put(`${this.url}/block/${userId}`, {});
  }

  public unblock(userId: ID) {
    return this.http.put(`${this.url}/unblock/${userId}`, {});
  }

  public getUserResearches() {
    return this.http.get<IPaginationOutput<IResearchCode>>(`${this.profileUrl}/Research/research-code`);
  }
}
